module.exports = __webpack_public_path__ + "static/media/image504.afa352fb.png";